<style type="text/less" lang="less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.InfluencerSettingsProfilePage__cover__profile-image-wrapper {
    left: 40px;
    bottom: -60px;
    z-index: 200;
}

.InfluencerSettingsProfilePage__name {
    margin: 20px 20px 20px 250px;
}

@media (max-width: @screen-xs-max) {
    .InfluencerSettingsProfilePage__cover {
        margin-bottom: 150px;
    }
    .InfluencerSettingsProfilePage__cover__profile-image-wrapper {
        bottom: -110px;
        left: 20px;
    }
    .InfluencerSettingsProfilePage__name {
        margin: 130px 20px -15px 20px;
        text-align: center;
    }
}
.InfluencerSettingsProfilePage {
    .SegmentItem__inner {
        .segment-name {
            color: #065c43;
        }
        .icon {
            filter: brightness(0) saturate(100%) invert(25%) sepia(17%) saturate(4068%)
                hue-rotate(127deg) brightness(95%) contrast(95%);
        }
    }
    .SegmentItem__inner .toggle-segement.toggled {
        ~ .icon {
            filter: none;
        }
        ~ .segment-name {
            color: var(--magic-color);
        }
    }
}
</style>

<script type="text/babel">
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import RatingStars from 'dashboard-js/components/reviews/RatingStars.vue'

export default {
    mixins: [RestoreOnPageBack],
    props: ['user'],

    components: {
        RatingStars,
    },

    data() {
        console.log('U!', this.user)
        return {
            form: new SparkForm({
              ...this.user,
              extra_notification_emails: this.user.extra_notification_emails || [],
            }),
            interestsForm: new SparkForm(),
            segments: null,
            formUpdateInterestsInfluencer: {
                successful: false,
                busy: false,
            },
        }
    },

    computed: {
        loading() {
            return typeof this.interestsForm.categories === 'undefined' || this.segments === null
        },
    },

    created() {
        this.onPageVisit(() => {
            axios
                .get(route('api.profile'))
                .then(response => (this.interestsForm = new SparkForm(response.data.data)))
                .then(this.saveState)

            axios
                .get(route('api.segments'))
                .then(response => (this.segments = response.data.data))
                .then(this.saveState)
        })
    },

    methods: {
        update() {
            if (window.selectedGooglePlace) {
                this.form.city = window.selectedGooglePlace.formatted_address
                this.form.city_latitude = window.selectedGooglePlace.geometry.location.lat()
                this.form.city_longitude = window.selectedGooglePlace.geometry.location.lng()
            }
            this.form.birthday = $('input[name="birthday"]').length > 0 ? $('input[name="birthday"]').val() : this.form.birthday;
            this.form.extra_notification_emails = this.form.extra_notification_emails !== null ? this.form.extra_notification_emails.filter(item => Boolean(item)) : []
            this.form.extra_notification_emails = this.form.extra_notification_emails.length === 0 ? null : this.form.extra_notification_emails
            Spark.sendFormData('put', route('api.profile.update'), this.form).then(response => {
                Bus.$emit('userUpdated', response.data)
                Object.assign(this.form, response.data)
                Object.assign(this.user, response.data)
            })
        },

        addExtraEmail(){
            if(this.form.extra_notification_emails === null){
                this.form.extra_notification_emails = ['']
            }else{
                this.form.extra_notification_emails.push('')
            }
        },
        removeExtraEmail(index){
            this.form.extra_notification_emails = this.form.extra_notification_emails.filter((_, idx) => idx !== index)
        },
        updateInterests() {
            Spark.put(route('api.profile.interests.update'), this.interestsForm)
        },

        updateCityCoordinates(place) {
            this.form.city_latitude = this.$get(place, 'coordinates.latitude', null)
            this.form.city_longitude = this.$get(place, 'coordinates.longitude', null)
        },
        openDeleteAccountPopup(confirmed) {
            if (typeof confirmed === 'undefined') {
                swal(
                    {
                        title: `Slet Din Konto`,
                        text: 'Advarsel: Denne handling kan ikke fortrydes. Er du sikker?',
                        customClass: 'danger',
                        showCancelButton: true,
                        confirmButtonText: 'Ja, slet kontoen',
                        cancelButtonText: 'Nej, luk popup',
                        closeOnConfirm: true,
                        allowEscapeKey: true,
                        allowClickOutside: true,
                        type: 'warning',
                    },
                    this.deleteAccount
                )
            }
        },
        deleteAccount() {
            // console.log(this.user)

            // Add your account deletion logic here
            axios
                .delete(route('app.users.delete', this.user.id))
                .then(response => {
                    console.log(response)

                    if (response.data.status === 200) {
                        window.location.href = response.data.url
                    } else {
                        swal({
                            title: 'Fejl',
                            text: response.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(error => {
                    console.error('Error deleting account:', error)
                })
        },
        updateInterestsInfluencer() {
            const checkedBoxes = document.querySelectorAll('.SegmentList input[type="checkbox"]:checked');
            const interests = Array.from(checkedBoxes).map(box => box.name.match(/\d+/)[0]);
            this.formUpdateInterestsInfluencer.busy = true;
            this.formUpdateInterestsInfluencer.successful = false;

            axios
                .post(route('influencer.settings.updateInterestsInfluencer', { interest: interests }))
                .then(response => {
                    
                    if (response.data.status == 'success') {
                        this.formUpdateInterestsInfluencer.successful = true;
                        this.formUpdateInterestsInfluencer.busy = false;

                    } else {
                        this.formUpdateInterestsInfluencer.busy = false;
                    }
                })
                .catch(error => {
                    console.error('Error deleting account:', error)
                })
        },
    },
}
</script>
